export function format_size (bytes) {
    var threshold = 1024;
    if(Math.abs(bytes) < threshold) {
        return bytes + ' B';
    }
    var units = ['kB','MB','GB','TB','PB','EB','ZB','YB'];
    var u = -1;
    do {
        bytes /= threshold;
        ++u;
    } while(Math.abs(bytes) >= threshold && u < units.length - 1);
    return bytes.toFixed(1)+' '+units[u];
}

export function urlB64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function prev(element, selector) {
  let prevElement = element.previousElementSibling;
  while (prevElement) {
    if (prevElement.matches(selector)) {
      return prevElement;
    }
    prevElement = prevElement.previousElementSibling;
  }
  return null;
}

export function nextAll(elem, selector) {
  var siblings = [];
  while ((elem = elem.nextElementSibling)) {
    if (!selector || elem.matches(selector)) {
      siblings.push(elem);
    }
  }
  return siblings;
}
export function prevAll(elem, selector) {
  var siblings = [];
  while ((elem = elem.previousElementSibling)) {
    if (!selector || elem.matches(selector)) {
      siblings.push(elem);
    }
  }
  return siblings;
}

export function fadeIn(elem) {
    elem.style.opacity = "0";
    window.getComputedStyle(elem).opacity;
    elem.style.transition = "opacity 0.5s ease-in";
    elem.style.opacity = "1";
}
export function fadeOut(elem) {
    elem.style.opacity = "1";
    window.getComputedStyle(elem).opacity;
    elem.style.transition = "opacity 0.5s ease-out";
    elem.style.opacity = "0";
}
